import React from "react";

const DashboardDataContext = React.createContext({
    appToken: "",
    testFunction: (attr) => {},
});

export default DashboardDataContext;
